export default __webpack_public_path__ + "static/media/CCHP.d071a0c7.jpg";